"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAlertCloseButton = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var style_utils_1 = require("@nef/style-utils");
var CloseButton_1 = __importDefault(require("../../../components/CloseButton"));
exports.StyledAlertCloseButton = styled_components_1.default(CloseButton_1.default)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n  height: 100%;\n  ", "\n"], ["\n  ", "\n  height: 100%;\n  ",
    "\n"])), style_utils_1.setPadding("x", 3), function (props) {
    return props.rtl
        ? styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          left: 0;\n          right: auto;\n        "], ["\n          left: 0;\n          right: auto;\n        "]))) : styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          right: 0;\n        "], ["\n          right: 0;\n        "])));
});
var AlertCloseButton = function (_a) {
    var canBeToggled = _a.canBeToggled, onClick = _a.onClick, rtl = _a.rtl;
    return canBeToggled ? react_1.default.createElement(exports.StyledAlertCloseButton, { toggle: onClick, rtl: rtl }) : null;
};
exports.default = AlertCloseButton;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map